import { Slide } from "@jelly/lesson";
import { task as task02 } from "../../../../../task/course-03/lesson-16/task-02";

const task: Slide = {
  titleHtml: `What happens with the amplitude of the sound if the distance between source and listener doubles?`,
  description: "Select the correct answer.",
  layout: {
    type: "simple",
    options: {
      components: {
        variant: "__task__",
        data: {
          id: task02.id,
        },
      },
    },
  },
};

export default task;
